export function isValidDate (value) {
  let parsedDate = Date.parse(value)
  return (!value || /^\s*$/.test(value)) || (!isNaN(parsedDate) && parsedDate > 0 && /^\d{2}\/\d{2}\/\d{4}$/.test(value))
}
